import { type IGridStrategy } from './abstract.strategy';
import { EventEmitter } from '../../../system/classes/event-emitter';
import { type IA9GridConstants } from '../../../grid/constants';
import { AngularInjector } from '../../../system/angular/AngularInjector';

export class FooterGridStrategy extends EventEmitter implements IGridStrategy {
    constructor(
        private strategy: IGridStrategy,
        header?: number
    ) {
        super();
        const a9GridConstants: IA9GridConstants = <any>AngularInjector.get('a9GridConstants');
        this.addHeader(header || a9GridConstants.headerRowHeight);
    }

    public getGridHeight(): number {
        return this.strategy.getGridHeight();
    }

    public getInnerGridHeight(): number {
        return this.strategy.getInnerGridHeight();
    }

    public getGridPageAmount(): number {
        return this.strategy.getGridPageAmount();
    }

    public addHeader(headerHeight = 0): void {
        this.strategy.addHeader(headerHeight);
    }

    public on(event, listener, options = null) {
        return this.strategy.on(event, listener, options);
    }

    public showPagination() {
        return this.strategy.showPagination();
    }

    getCssClasses() {
        return this.strategy.getCssClasses();
    }

    isStretchable() {
        return this.strategy.isStretchable();
    }

    public usesAllItems(): boolean {
        return this.strategy.usesAllItems();
    }

    public detach() {
        this.strategy.detach();
    }

    public setGridElement(gridElement: HTMLElement): void {
        this.strategy.setGridElement(gridElement);
    }
}
